/* eslint-disable semi */

/**
 * プラン月数にサフィックスを付与する
 * @param {*} value
 */
export function suffix (value, suffix) {
  if (value === null || value === undefined) {
    return value
  }
  if (String(value).trim().length !== 0) {
    return String(value) + suffix;
  } else {
    return value
  }
};



// WEBPACK FOOTER //
// ./src/app/filters/suffix.js